import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { Body } from '@nerdwallet/react-typography';

import HeroNavTile from './hero-nav-tile';

const HeroNav = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, nav) => (
    <HeroNavTile {...tile} key={`item-${nav}`} />
  ));

  const HeroContainer = (
    <div
      className={classNames([
        'hero-nav__container',
        classes('margin-horizontal-3'),
      ])}
    >
      {renderedTiles}
    </div>
  );

  return (
    <div
      className={classNames([
        'hero-nav__box',
        classes('margin-horizontal-auto'),
      ])}
    >
      <Body
        size="large"
        className={classNames([
          'hero-nav__header',
          classes('text-align-center'),
          classes('margin-vertical-5'),
          classes('margin-horizontal-4'),
        ])}
      >
        Let’s crush your money goals. Where do you want to start?
      </Body>
      {HeroContainer}
    </div>
  );
};

HeroNav.displayName = 'HeroNav';

HeroNav.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(HeroNav.propTypes)),
  className: PropTypes.string,
  nav: PropTypes.string,
};

export default HeroNav;
